import React from 'react';
import { useDispatch } from "react-redux";
import ListItem from '@material-ui/core/ListItem';
import LongMenu from "../longMenu";
import './compactQuestion.scss';
import MathJax from "react-mathjax4";
import {
    openQuestionInPlayer,
    activePracticeQuesIndex,
    moveActivePracticeIndex,
    changePracticeQuestionFilter
} from "examsbook-react-sdk/actions";
import { useNavigate } from 'react-router-dom';

const classMap = {
    "CORRECT": "correct-ans",
    "INCORRECT": "incorrect-ans",
    "UN_ATTEMPTED": ""
};

/**
 * Compact question to show in question list screens.
 */

function CompactQuestion(props) {
    const {
        questionNo,
        question,
        totalQuestions,
        index,
        selectedSubjectTopic,
        selectedIndex,
        history,
        singleQuesUrl
    } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    /**
     * Select question to show on UI
     * @param question
     */
    function selectQuestion(ques) {
        dispatch(openQuestionInPlayer(ques));
        navigate(singleQuesUrl + ques.slug);
        //if there are tabs
        if (selectedIndex) {
            props.setTestSeriesIndex(selectedIndex);
        }

    }

    function selectQuestionIndex(selectedQuestion, questionIndex) {
        navigate(singleQuesUrl + selectedQuestion.slug);
        dispatch(activePracticeQuesIndex(questionIndex));
        dispatch(changePracticeQuestionFilter('ALL'));
        let moveQuestion = questionIndex - 5;
        dispatch(moveActivePracticeIndex((moveQuestion > 0) ? moveQuestion * 42 : -0));
    }

    //show class based on status
    function getClass(status) {
        return classMap[status];
    }

    // toggle saved state of a quiz.
    function toggleSavedQuestion(event) {
        event.stopPropagation();
        props.toggleSavedQuestion();
    }

    return (
        <ListItem
            onClick={selectedSubjectTopic ? () => selectQuestionIndex(question, index) : () => selectQuestion(question)}>
            <div className={"saved-questions " + (getClass(question.status))}>
                <div className={question.status === 'CORRECT' ? 'correct-option' :
                    question.status === 'INCORRECT' ? 'incorrect-option' : ''}>
                    {question.status === 'CORRECT' ? <i className="fa fa-check-circle"/> :
                        question.status === 'INCORRECT' ? <i className="fa fa-times-circle"/> : null}
                </div>
                <div className="saved-button">
                    <div className="saved-type">
                        <p>
                            {questionNo} of {totalQuestions}
                        </p>
                    </div>
                    <ul>
                        <li onClick={toggleSavedQuestion}>
                            <i className={'fa ' + (!question.isSaved ? 'fa-bookmark-o' : 'fa-bookmark')}/>
                        </li>
                        <li>
                            <LongMenu question={question}/>
                        </li>
                    </ul>
                </div>
                <h4>
                    <MathJax.Context input="tex">
                        <MathJax.Html html={question.title}/>
                    </MathJax.Context>
                </h4>

            </div>
        </ListItem>
    );
}

export default CompactQuestion;
